import dayjs from 'dayjs';
import {formatRut} from "presentation/common/helpers/validate/rut/rut";
import {formatCurrency} from "presentation/common/helpers/utils";

const getVehicleDetail = (vehicle) => ({
  items: [
    {name: 'PPU', value: vehicle?.patente || '-'},
    {name: 'Tipo vehículo', value: vehicle?.tipo_vehiculo || '-'},
    {name: 'Marca', value: vehicle?.marca || '-'},
    {name: 'Modelo', value: vehicle?.modelo || '-'},
    {name: 'Año', value: (vehicle?.anno?.trim() !== '-1' && vehicle?.anno?.trim() !== '0' && vehicle?.anno) || '-'},
    {name: 'Color', value: vehicle?.color || '-'},
    {name: 'N° Motor', value: vehicle?.no_motor || '-'},
    {name: 'N° Chasis/VIN', value: vehicle?.no_chassis || '-'},
    {name: 'Combustible', value: vehicle?.combustible || '-'},
    {name: 'PBV', value: vehicle?.pbv || '-'},
  ],
  name: 'Vehículo',
});

const getBillDetail = (bill) => ({
  items: [
    {name: 'Fecha emisión', value: (bill?.fecha_emision && dayjs(bill?.fecha_emision).format('DD/MM/YYYY')) || '-'},
    {name: 'N° Factura', value: bill?.num_factura || '-'},
    {name: 'Rut emisor', value: formatRut(bill?.rut_emisor) || '-'},
    {name: 'Monto neto', value: formatCurrency(Number(bill?.monto_neto)) || '-'},
    {name: 'IVA', value: (bill?.iva !== '-1' && bill?.iva) || '-'},
    {name: 'Monto total', value: formatCurrency(Number(bill?.monto_total)) || '-'},
  ],
  name: 'Factura',
});

const compraPara = (item) => ({
  items: [
    {name: 'Nombre', value: item?.nombre || '-'},
    {name: 'Run o Rut', value: formatRut(item?.rut) || '-'},
    {name: 'Correo electrónico', value: item?.correo || '-'},
    {name: 'Comuna', value: item?.comuna || '-'},
    {
      name: 'Domicilio',
      value:
        !item?.r_domicilio || item?.r_domicilio?.trim() === '0' || item?.r_domicilio?.trim() === '-1'
          ? '-'
          : item?.r_domicilio,
    },
  ],
  name: 'Compra para',
});

const owner = (item) => [
  {
    name: 'Nombre',
    value: `${item?.nombre || ''} ${item?.primer_apellido || ''} ${item?.segundo_apellido || ''}`.trim() || '-',
  },
  {name: 'Rut', value: formatRut(item?.rut) || '-'},
  {name: 'Correo electrónico', value: item?.correo || '-'},
  {name: 'Comuna', value: item?.comuna || '-'},
  {name: 'Domicilio', value: (item?.r_domicilio?.trim() !== '0' && item?.r_domicilio) || '-'},
];

const document = (item) => ({
  items: [
    {name: 'Fecha', value: (item?.inserted_at &&  dayjs(item?.inserted_at).format('DD/MM/YYYY')) || '-'},
    {name: 'Estado', value: item?.request_status?.replace(/_/g, ' ') || '-'},
    {name: 'Servicios', value: item?.servicios || '-'},
    {name: 'Monto', value: formatCurrency(item?.amount_str) || '-'},
    {name: 'Comprobante pago', value: item?.comprobante_pago || '-'},
  ],
  name: 'Solicitud',
});

export const getDetail = (props) => {
  const vehicleSection = getVehicleDetail(props.detailInfo?.vehiculo);

  return [
    props.detailInfo?.solicitud && document(props.detailInfo?.solicitud),
    props.detailInfo?.factura && getBillDetail(props.detailInfo?.factura),
    props.detailInfo?.adquirientes && {
      items:
        props.detailInfo?.adquirientes
          ?.map((item, index) => {
            const ownerItem = owner(item);

            if (index !== (props.detailInfo?.adquirientes?.length) - 1) {
              return ownerItem.concat({name: '', value: ''});
            }

            return ownerItem;
          })
          ?.flat(props.detailInfo?.adquirientes?.length * 2 || 0) || [],
      name: 'Adquiriente(s)',
    },
    props?.detailInfo?.compra_para &&
    (props?.detailInfo?.es_comprapara || props?.detailInfo?.compra_para?.rut) &&
    compraPara(props?.detailInfo?.compra_para),
    props.detailInfo?.vehiculo && vehicleSection,
  ].filter(group => !!group);
};
